import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";

import { PaymentChartCardMoneyIcon } from "../../../../assets/icons/MUI/PaymentIcons";
import { TransactionProps } from "../../payment.types";

import RechartsLineChart from "./RechartsLineChart";

const Transaction = ({ weeklyData, lastWeek, previousWeek, totalPaymentTotal, transactionTotal }: TransactionProps) => {
  const { t } = useTranslation();

  const formattedWeeklyData = weeklyData.map((item) => ({
    day: item.day,
    [lastWeek]: item.lastWeekValue,
    [previousWeek]: item.previousWeekValue,
    currency: transactionTotal?.currency || "",
  }));

  return (
    <Box
      sx={{
        borderRadius: "8px",
        background: "#F7F7F9",
        display: "flex",
        padding: "20px",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "32px",
        flex: "1 0 0",
      }}
    >
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            color: "var(--Dark---1000, #111)",
            fontFamily: "Montserrat",
            fontSize: "18px",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "28px",
            display: "flex",
            gap: "8px",
            alignItems: "center",
          }}
        >
          <PaymentChartCardMoneyIcon />
          {t("pages.payment.paymentLinks.transaction")}
        </Typography>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            width: "fit-content",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <Box
              sx={{
                width: "20px",
                borderBottom: "2px dashed #9FBFB6",
              }}
            />
            <Typography
              sx={{
                color: "#67696B",
                fontFamily: "Montserrat",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "20px",
              }}
            >
              {t("pages.payment.paymentLinks.totalPayment")}
            </Typography>
          </Box>
          {totalPaymentTotal?.currency && totalPaymentTotal?.amount ? (
            <Typography
              sx={{
                color: "var(--Dark---1000, #111)",
                fontFamily: "Montserrat",
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "32px",
              }}
            >
              {`${totalPaymentTotal?.amount / 100} ${totalPaymentTotal?.currency.toUpperCase()}`}
            </Typography>
          ) : (
            "__"
          )}
        </Box>
        <Box
          sx={{
            width: "fit-content",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <Box
              sx={{
                width: "20px",
                borderBottom: "2px solid #106048",
              }}
            />
            <Typography
              sx={{
                color: "#67696B",
                fontFamily: "Montserrat",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "20px",
              }}
            >
              {t("pages.payment.paymentLinks.paidPayment")}
            </Typography>
          </Box>
          {transactionTotal?.currency && transactionTotal?.amount ? (
            <Typography
              sx={{
                color: "var(--Dark---1000, #111)",
                fontFamily: "Montserrat",
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "32px",
              }}
            >
              {`${transactionTotal?.amount / 100} ${transactionTotal?.currency.toUpperCase()}`}
            </Typography>
          ) : (
            "__"
          )}
        </Box>
      </Box>
      <Typography
        sx={{
          color: "#242236",
          fontSize: "14px",
          fontStyle: "normal",
          fontWeight: 700,
          lineHeight: "14px",
          display: "block",
          textDecorationLine: "underline",
          textDecorationStyle: "dashed",
        }}
      >
        {t("pages.payment.paymentLinks.last7Days")}
      </Typography>
      <RechartsLineChart
        data={formattedWeeklyData}
        lines={[
          { dataKey: lastWeek, stroke: "#106048" },
          { dataKey: previousWeek, stroke: "#9FBFB6", strokeDasharray: "5 5" },
        ]}
      />
    </Box>
  );
};

export default Transaction;
